import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type AccessControlIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const AccessControlIllustration = ({ ...props }: AccessControlIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={0} strokeLinecap="square" fill="#141B4D">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 14C21 7.92487 25.9249 3 32 3C38.0751 3 43 7.92487 43 14C43 14.5523 43.4477 15 44 15C44.5523 15 45 14.5523 45 14C45 6.8203 39.1797 1 32 1C24.8203 1 19 6.8203 19 14V24H12C7.58172 24 4 27.5817 4 32V56C4 60.4183 7.58172 64 12 64H52C56.4183 64 60 60.4183 60 56V32C60 27.5817 56.4183 24 52 24H21V14ZM58 32V56C58 59.3137 55.3137 62 52 62H12C8.68629 62 6 59.3137 6 56V32C6 28.6863 8.68629 26 12 26H52C55.3137 26 58 28.6863 58 32Z"
        fill="#141B4D"
      />
      <path
        d="M33.7583 43.5938C35.086 42.943 36 41.5783 36 40C36 37.7909 34.2091 36 32 36C29.7909 36 28 37.7909 28 40C28 41.5783 28.914 42.943 30.2417 43.5938L28.3354 50.7423C28.1661 51.3772 28.6446 52 29.3016 52H34.6984C35.3554 52 35.8339 51.3772 35.6646 50.7423L33.7583 43.5938Z"
        fill="#141B4D"
      />
    </g>
  </BaseIllustration>
);

AccessControlIllustration.displayName = 'AccessControlIllustration';
